<template>
  <div>
    <Header :self="self" />
    <div class="container quote-view">
      <div class="alert alert-danger" role="alert" v-if="error">
        {{error.message}}
      </div>
      <p class="text-center gqp-header" v-if="!self.isPro">Like Quozio? You'll ❤️ Quozio Pro! <router-link :to="{name: 'get-quozio-pro', query: {ref: 'VQ'}}">Check it out</router-link>.</p>
      <div class="quote-view-image-panel text-center small-scroll">
        <img :src="quote.imageUrls.large" @dblclick="toggleExpand()" id="quote-view-image" />
      </div>
      <div class="m-2 text-center">
        <div class="d-flex justify-content-center">
          <i class="fab fa-pinterest-square fa-2x pinterest m-1" @click="shareToPinterest()"></i>
          <i class="fab fa-facebook-square fa-2x facebook m-1" @click="shareToFacebook()"></i>
          <i class="fab fa-twitter-square fa-2x twitter m-1" @click="shareToTwitter()"></i>
          <!--<button class="btn btn-secondary btn-sm m-1 btn-quote-action" v-b-modal.modal-send-by-email v-show="self.userId"><i class="fas fa-envelope"></i> Send</button>-->
          <!--<button class="btn btn-secondary btn-sm m-1 btn-quote-action" v-b-modal.modal-create-account-send-email v-show="!self.userId"><i class="fas fa-envelope"></i> Send</button>-->
          <button class="btn btn-secondary btn-sm m-1 btn-quote-action" v-b-modal.modal-download><i class="fas fa-cloud-download-alt"></i> Download</button>
          <button class="btn btn-success btn-sm m-1 btn-quote-action" @click="openSave()" v-show="self.userId"><i class="fas fa-file-import"></i> Save</button>
          <button class="btn btn-success btn-sm m-1 btn-quote-action" v-show="!self.userId" v-b-modal.modal-create-account-save-quote><i class="fas fa-file-import"></i> Save</button>
        </div>
      </div>
      <div class="text-center mb-2">
        <button class="btn btn-primary btn-primary btn-pill" @click="makeYourOwn()">Make Your Own Quote</button>
      </div>
      <div class="m-2">
        <p class="quote" v-show="quote.quote">"{{quote.quote}}"</p>
        <p class="author" v-show="quote.author">- {{quote.author}}</p>
      </div>
      <div v-if="template.attributionProvider" class="attribution">Background image by <a :href="template.attributionUrl" target="_blank">{{template.attributionName}}</a> on <a :href="template.attributionProviderUrl" target="_blank" class="text-capitalize">{{template.attributionProvider}}</a></div>
    </div>

    <b-modal id="modal-board-select" scrollable>
      <div class="alert alert-danger" role="alert" v-if="modalError">
        {{modalError.message}}
      </div>
      <template v-slot:modal-title>
        Where do you want to save it?
      </template>
      <div class="" v-if="!showCreateBoard">
        <div class="boards-select-wrapper justify-content-left">
          <div class="text-center mb-2">
            <button class="btn btn-primary btn-success btn-pill" @click="showCreateBoard = true">Create New Board</button>
          </div>
          <div v-for="(board, index) in boards.data" class="board-select-wrapper pointer" @click="save(board.boardId)">
            <div class="board-select-icon">
              <img :src="board.previewImageUrls.square" />
            </div>
            <div class="board-select-text">
              {{board.name}}
              <div class="sub text-secondary">
                <span>{{board.itemCount}} <span v-if="board.itemCount === 1">Quote</span><span v-if="board.itemCount !== 1">Quotes</span></span>
                <span v-if="board.private" title="This board is private">&nbsp;<i class="fas fa-lock"></i></span>
                <span v-if="board.hidden && !board.private" title="This board is hidden">&nbsp;<i class="fas fa-eye-slash"></i></span>
                <span v-if="board.userCount > 1" title="This is a group board">&nbsp;<i class="fas fa-user-friends"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showCreateBoard">
        <h5>Create a new board</h5>
        <div class="form-group" v-bind:class="{ 'form-group-error': $v.newBoard.name.$error }">
          <label for="name">Name</label>
          <input type="text" v-model.trim.lazy="$v.newBoard.name.$model" class="form-control" id="name" placeholder="What do you want to call this board?">
          <div class="error-input">Please provide a name</div>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" id="private" v-model="newBoard.private">
          <label class="form-check-label" for="private">Make this a private board</label>
          <small class="form-text text-muted">Private boards can only be seen and accessed by you and others you invite to the board.</small>
        </div>
        <div class="form-check" v-show="!newBoard.private">
          <input type="checkbox" class="form-check-input" id="hidden" v-model="newBoard.hidden">
          <label class="form-check-label" for="hidden">Don't show this board with my profile</label>
          <small class="form-text text-muted">Others will be able to access this board, but it will not be listed on your profile page.</small>
        </div>
      </div>
      <template v-slot:modal-footer v-bind:class="{ 'hide-modal-footer': showCreateBoard === false }">
        <div v-if="!showCreateBoard"></div>
        <div class="board-select-footer right pointer" v-if="showCreateBoard">
          <button class="btn btn-light btn-sm mb-2" @click="showCreateBoard = false">Cancel</button>
          <button class="btn btn-success btn-sm ml-2 mb-2" @click="createBoard()"><i class="fas fa-check"></i> Save</button>
        </div>
      </template>
    </b-modal>

    <b-modal id="modal-send-by-email" title="Send Quote" @ok="sendByEmail()">
      <div class="alert alert-danger" role="alert" v-if="modalError">
        {{modalError.message}}
      </div>
      <p class="text-center"><i class="far fa-envelope fa-5x text-primary"></i></p>
      <p class="my-4">
        <div class="form-group">
          <label for="email" class="text-center"><strong>Email Address</strong></label>
          <input type="email" id="email" v-model="sendByEmail.email" class="form-control" placeholder="someone@example.com" />
        </div>
      </p>
      <template v-slot:modal-footer="{ ok, cancel, hide }">
        <div>
          <button class="btn btn-primary btn-sm" @click="sendQuoteByEmail()" :disabled="submitting.sendQuoteByEmail">Send</button>
        </div>
      </template>
    </b-modal>

    <b-modal id="modal-download" title="Download Quote" @ok="download()">
      <div class="alert alert-danger" role="alert" v-if="modalError">
        {{modalError.message}}
      </div>
      <p class="text-center"><i class="fas fa-cloud-download-alt fa-5x text-primary"></i></p>
      <p class="my-4">
        <h5 class="text-center">What size image would you like to download?</h5>
      </p>
      <p class="my-4">
        <div class="form-check mb-3">
          <input class="form-check-input" type="radio" name="downloadSize" v-model="downloadSize" id="downloadSizeSmall" value="small" @change="setDownloadUrl()">
          <label class="form-check-label" for="downloadSizeSmall">
            Small
          </label>
        </div>
        <div class="form-check mb-3">
          <input class="form-check-input" type="radio" name="downloadSize" v-model="downloadSize" id="downloadSizeMedium" value="medium" @change="setDownloadUrl()">
          <label class="form-check-label" for="downloadSizeMedium">
            Medium
          </label>
        </div>
        <div class="form-check mb-3">
          <input class="form-check-input" type="radio" name="downloadSize" v-model="downloadSize" id="downloadSizeLarge" value="large" @change="setDownloadUrl()">
          <label class="form-check-label" for="downloadSizeLarge">
            Large
          </label>
        </div>
        <div class="form-check mb-3">
          <input class="form-check-input" type="radio" name="downloadSize" v-model="downloadSize" id="downloadSizeMax" value="max" :disabled="!self.isPro" @change="setDownloadUrl()">
          <label class="form-check-label" for="downloadSizeMax">
            Full Size (High Definition / Printable) <span class="badge badge-danger">Pro</span>
          </label>
        </div>
      </p>
      <div v-if="!self.isPro">
        <p class="my-4 text-center">
          Get Quozio Pro and access additional designs, add custom watermarks, download full size images and more!
        </p>
        <p class="my-4 text-center">
          <router-link class="btn btn-success btn-sm" :to="{ name: 'get-quozio-pro', query: { ref: 'DLFSQ' } }">Learn More</router-link>
        </p>
      </div>
      <template v-slot:modal-footer="{ ok, cancel, hide }">
        <div>
          <a class="btn btn-primary btn-sm" v-bind:href="downloadUrl" @click="closeDownloadModal()">Download</a>
        </div>
      </template>
    </b-modal>

    <b-modal id="modal-create-account-send-email" title="Send Quote" hide-footer>
      <div class="alert alert-danger" role="alert" v-if="modalError">
        {{modalError.message}}
      </div>
      <p class="text-center"><i class="far fa-envelope fa-5x text-primary"></i></p>
      <p class="my-4">
        <h5 class="text-center">Want to send this quote by email?</h5>
      </p>
      <p class="my-4 text-center">
        Join Quozio and email your favorite quotes, save them to your account and more. It's free!
      </p>
      <p class="my-4 text-center">
        <router-link class="btn btn-success btn-lg" :to="{ name: 'join', query: { redirect: getRoutePath() } }">Join Now, It's Free!</router-link>
      </p>
      <p class="my-4 text-center">
        Already have an account? <router-link :to="{ name: 'sign-in', query: { redirect: getRoutePath() } }" v-cloak>Sign In</router-link>.
      </p>
    </b-modal>

    <b-modal id="modal-create-account-save-quote" title="Save Quote" hide-footer>
      <div class="alert alert-danger" role="alert" v-if="modalError">
        {{modalError.message}}
      </div>
      <p class="text-center"><i class="fas fa-file-import fa-5x text-primary"></i></p>
      <p class="my-4">
        <h5 class="text-center">Want to save this quote?</h5>
      </p>
      <p class="my-4 text-center">
        No problem! Join Quozio to keep your favorite quotes in a safe place, making them easy to find, share and download. It's free!
      </p>
      <p class="my-4 text-center">
        <router-link class="btn btn-success btn-lg" :to="{ name: 'join', query: { redirect: getRoutePath() } }">Join Now, It's Free!</router-link>
      </p>
      <p class="my-4 text-center">
        Already have an account? <router-link :to="{ name: 'sign-in', query: { redirect: getRoutePath() } }" v-cloak>Sign In</router-link>.
      </p>
    </b-modal>
    <Footer />
  </div>
</template>

<script>
  import Header from "@/components/header";
  import Footer from "@/components/footer";
  import { mapState } from "vuex";
  import { required } from "vuelidate/lib/validators";

  const getTemplateIdFromParams = (param) => {
    let templateIdParts = param.split('-');
    return templateIdParts[0];
  }

  const getKeyFromParams = (param) => {
    let templateIdParts = param.split('-');
    return templateIdParts.length > 1 ? templateIdParts.pop() : null;
  }

  export default {
    components: { Header, Footer },
    data() {
      return {
        quote: { imageUrls: {}, downloadUrls: {} },
        template: {},
        promptSaveOnLoad: false,
        boards: { data: [] },
        showCreateBoard: false,
        downloadSize: "large",
        downloadUrl: null,
        newBoard: { name: null, private: false },
        error: null,
        modalError: null,
        sendByEmail: { email: null },
        submitting: { save: false, createBoard: false, sendQuoteByEmail: false },
      };
    },
    head({ $config }) {
      return {
        title: `${this.quote.name} - Quozio`,
        link: [
          { rel: 'canonical', href: this.quote.link }
        ],
        meta: [
          { hid: "description", name: "description", content: this.quote.quote },
          { hid: "og:url", name: "og:url", content: this.quote.link },
          { hid: "og:title", name: "og:title", content: this.quote.name },
          { hid: "og:description", name: "og:description", content: this.quote.quote },
          { hid: "og:image", name: "og:image", content: this.quote.imageUrls.large }
        ]
      }
    },
    async asyncData({ store, app, params, error, redirect, $config }) {

      await store.dispatch("self/get", app.$cookies);

      // Indicate if the user came from the design page.
      var promptSaveOnLoad = false;
      var design = await store.dispatch("design/get");
      if (design.templateId && design.isNew) {
        promptSaveOnLoad = true;
      }

      let templateId = getTemplateIdFromParams(params.templateId);
      let key = getKeyFromParams(params.templateId);

      // Get the quote
      let quoteResponse = await app.$dataService.get(`/quotes/${params.quoteId}`, { templateId: templateId, key: key });
      if (quoteResponse.error) {
        return error({ statusCode: quoteResponse.error.status, message: quoteResponse.error.message, reference: quoteResponse.error.reference });
      }

      if (design.templateId && !design.isNew) {
        // Since they came from the design page, load an uncached version of the image to get the latest changes.
        const randomNumber = Math.floor(Math.random() * 1000000000);
        for (const i in quoteResponse.data.imageUrls) {
          quoteResponse.data.imageUrls[i] += "?cb=" + randomNumber;
        }
      }

      // Get the template
      let templateResponse = await app.$dataService.get(`/templates/${templateId}`);
      if (templateResponse.error) {
        return error({ statusCode: templateResponse.error.status, message: templateResponse.error.message, reference: templateResponse.error.reference });
      }

      // Clear the state.
      await store.dispatch("design/delete");

      return { quote: quoteResponse.data, template: templateResponse.data, promptSaveOnLoad: promptSaveOnLoad, downloadUrl: `${quoteResponse.data.downloadUrls["large"]}` };
    },
    async mounted() {

      // Add a listener for the modal close.
      this.$root.$on("bv::modal::hidden", (bvEvent, modalId) => {
        this.modalError = null;
        this.showCreateBoard = false;
      })

      // If this is a new design, pop the "Save" modal.
      if (this.promptSaveOnLoad) {
        this.openSave();
      }

    },
    methods: {
      toggleExpand() {
        let quoteImageEl = document.getElementById("quote-view-image");
        if (quoteImageEl) {
          quoteImageEl.classList.toggle("expanded");
        }
      },
      async save(boardId) {

        // If they haven't supplied a board, save it to the default board.
        let url = "/quotes/save";
        if (boardId) {
          url = `/boards/${boardId}/boardItems`;
        }

        let payload = { quoteId: this.quote.quoteId, templateId: this.template.templateId, key: this.quote.imageUrls.key };;
        this.submitting.save = true;
        this.$nuxt.$loading.start();
        let response = await this.$dataService.post(url, payload, { expand: "board" });
        this.submitting.save = false;
        if (response.error) {
          this.modalError = response.error;
          this.$nuxt.$loading.finish();
          return;
        }
        this.$bvModal.hide("modal-board-select");
        let boardItem = response.data;

        this.$nuxt.$loading.finish();

        this.$ga.event("Quote", "Item Saved", "q-" + this.quote.quoteId + "/" + this.template.templateId);

        if (boardItem.boardItemId) {
          let toast = this.$toast.show("Saved!", {
            theme: "outline",
            position: "bottom-center",
            duration: 5000,
            iconPack: "fontawesome",
            icon: "thumbs-up",
            type: "success",
            keepOnHover: true,
            action: {
              text: 'Take a look',
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
                this.$router.push({ name: "board-boardId-boardSlug", params: { boardSlug: boardItem.board.slug, boardId: boardItem.board.boardId } });
              }
            }
          });
        }
      },
      async createBoard() {
        this.$v.$touch();
        if (this.newBoard.private) {
          this.newBoard.hidden = true;
        }
        if (!this.$v.$invalid) {
          this.submitting.createBoard = true;
          this.$nuxt.$loading.start();
          let response = await this.$dataService.post("/boards", this.newBoard);
          this.submitting.createBoard = false;
          if (response.error) {
            this.error = response.error;
            this.$nuxt.$loading.finish();
            return;
          }
          let board = response.data;
          this.$ga.event("Board", "Board Created", board.boardId, board.private ? 0 : 1);
          await this.save(board.boardId);
        }
      },
      async openSave() {
        this.$bvModal.show("modal-board-select");
        if (!this.boards.data.length) {
          let response = await this.$dataService.get("/boards", { includePreviewImages: true });
          if (response.error) {
            this.error = response.error;
            return;
          }
          this.boards = response.data;
        }
      },
      setDownloadUrl() {
        this.downloadUrl = `${this.quote.downloadUrls[this.downloadSize]}`;
      },
      closeDownloadModal() {
        setTimeout(() => { this.$bvModal.hide("modal-download"); }, 500);
      },
      async sendQuoteByEmail() {
        let payload = { email: this.sendByEmail.email, templateId: this.template.templateId };
        this.$nuxt.$loading.start();
        this.submitting.sendQuoteByEmail = true;
        this.modalError = null;
        let response = await this.$dataService.post(`/quotes/${this.$route.params.quoteId}/sendByEmail`, payload);
        this.submitting.sendQuoteByEmail = false;
        if (response.error) {
          this.modalError = response.error;
          this.$nuxt.$loading.finish();
          return;
        }
        this.$bvModal.hide("modal-send-by-email");
        this.sendByEmail.email = null;

        this.$nuxt.$loading.finish();

        this.$ga.event("Social", "Email Sent", "q-" + this.quote.quoteId + "/" + this.template.templateId);

        let toast = this.$toast.show("Sent!", {
          theme: "outline",
          position: "bottom-center",
          duration: 5000,
          iconPack: "fontawesome",
          icon: "thumbs-up",
          type: "success",
          keepOnHover: true,
        });
      },
      async makeYourOwn() {
        this.$router.push({ name: 'index' });
        this.$ga.event("UIUX", "Make Your Own", "From Quote");
      },
      getPageUrl(baseUrl, quoteId, templateId, slug) {
        return `${baseUrl}/quote/${quoteId}/${templateId}/${slug}`;
      },
      shareToFacebook() {
        let shareUrl = this.quote.link;
        let url = `https://www.facebook.com/dialog/share?app_id=${this.$config.FACEBOOK_APP_ID}&display=popup&href=${shareUrl}`;
        let options = "toolbar=0,status=0,resizable=1,width=626,height=436";
        window.open(url, "sharer", options);
        this.$ga.event("Social", "Share - Facebook", "q-" + this.quote.quoteId + "/" + this.template.templateId);
      },
      shareToTwitter() {
        let maxTweetLength = 257; // 280 max content length minus 23 characters for the URL (provided URL will be shortened)
        let text = this.quote.quote.substring(0, 257);
        // Can you fit the author in?
        if (this.quote.author && this.quote.author.length < maxTweetLength - (text.length + 2)) {
          text = `${text} -${this.quote.author}`
        }

        let shareUrl = this.quote.link;
        let url = `https://twitter.com/intent/tweet?text=${text}&url=${shareUrl}`;
        let options = "toolbar=0,status=0,resizable=1,width=550,height=390";
        window.open(url, "tweeter", options);
        this.$ga.event("Social", "Share - Twitter", "q-" + this.quote.quoteId + "/" + this.template.templateId);
      },
      shareToPinterest() {
        let shareUrl = this.quote.link;
        let text = this.quote.author != null ? `${this.quote.quote} -${this.quote.author}` : this.quote.quote;

        // Unsplash requires credit in social media text if their API was used for the quote background.
        if (this.template.attributionProvider == "unsplash") {
          text += ` (Image background by ${this.template.attributionName} on Unsplash)`;
        }

        let url = `https://www.pinterest.com/pin/create/button/?url=${shareUrl}&media=${this.quote.imageUrls.large}&description=${text}`;
        let options = "toolbar=0,status=0,resizable=1,width=800,height=600";
        window.open(url, "pinner", options);
        this.$ga.event("Social", "Share - Pinterest", "q-" + this.quote.quoteId + "/" + this.template.templateId);
      },
      getRoutePath() {
        return this.$route.path;
      }
    },
    computed: {
      ...mapState("self", { self: "self" }),
      ...mapState("design", { design: "design" }),
    },
    validations: {
      newBoard: {
        name: {
          required
        }
      }
    }
  };
</script>
